import GenericRequest, { METHOD_PUT } from '../../../../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../../../../shared/webservices/endpoint';

export default class MarkReadMessagesRequest extends GenericRequest {

    messageIds;

    constructor(messageId) {
        super(METHOD_PUT, ApiEndpoints.MESSAGES_MARK_READ);

        this.messageIds = [messageId];
    }

    overrideRequest() {
        const request = {};
        request.messageIds = this.messageIds;
        return request;
    }
}



// WEBPACK FOOTER //
// ./src/app/messages-notifications/messages/to-refactor/shared/ws/MarkReadMessagesRequest.js